var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-component bg-white rounded-lg transition-all duration-200",class:[
		_vm.shadowClass,
		_vm.hoverClass,
		_vm.clickable ? 'cursor-pointer' : '',
		_vm.bordered ? 'border border-border' : '',
		_vm.customClass,
	],on:{"click":_vm.handleClick}},[(_vm.$slots.header || _vm.title)?_c('div',{staticClass:"card-header px-6 py-4",class:[
			_vm.headerClass,
			!_vm.noDivider && (_vm.$slots.default || _vm.$slots.body)
				? 'border-b border-border'
				: '',
		]},[_vm._t("header",function(){return [_c('div',{staticClass:"flex items-center justify-between"},[_c('div',{staticClass:"flex items-center gap-3"},[(_vm.icon)?_c('div',{staticClass:"flex items-center justify-center w-10 h-10 rounded-lg",class:_vm.iconBgClass},[_c('i',{staticClass:"text-lg",class:_vm.icon,style:({ color: _vm.iconColor })})]):_vm._e(),_c('div',[_c('h3',{staticClass:"text-lg font-semibold text-text-primary"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.title)+"\n\t\t\t\t\t\t")]),(_vm.subtitle)?_c('p',{staticClass:"text-sm text-text-secondary mt-0.5"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.subtitle)+"\n\t\t\t\t\t\t")]):_vm._e()])]),_vm._t("header-actions")],2)]})],2):_vm._e(),(_vm.$slots.default || _vm.$slots.body)?_c('div',{staticClass:"card-body",class:[_vm.padding ? _vm.paddingClass : '', _vm.bodyClass]},[_vm._t("body",function(){return [_vm._t("default")]})],2):_vm._e(),(_vm.$slots.footer)?_c('div',{staticClass:"card-footer px-6 py-4",class:[
			_vm.footerClass,
			!_vm.noDivider && (_vm.$slots.default || _vm.$slots.body)
				? 'border-t border-border'
				: '',
		]},[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }